
import React from "react";
import "./About.css";

import img1 from "../../assets/library1.jpg";
import img2 from "../../assets/library2.png";
import img3 from "../../assets/library3.png";
import img4 from "../../assets/library4.png";
import img5 from "../../assets/library5.png";
import img6 from "../../assets/library6.png";

const About = () => {
  return (
    <div className="about-page">

      {/* ================= HERO ================= */}

      <section className="about-hero">
        <img
          src={img1}
          alt="Ghalib Library"
          className="about-hero-image"
        />

        <div className="about-hero-overlay">
          <h1 className="about-hero-title">
            Ghalib Library
          </h1>

          <p className="about-hero-subtitle">
            Preserving Knowledge, Literature and Culture Since 1971
          </p>
        </div>
      </section>


      {/* ================= INTRODUCTION ================= */}

      <section className="about-content-section">

        <div className="about-text">
          <h2 className="about-heading">
            About Ghalib Library
          </h2>

          <div className="about-line"></div>

          <p className="about-paragraph">
            Ghalib Library is one of Karachi's most respected literary
            institutions, established to preserve the rich heritage of Urdu
            literature and promote intellectual growth among students,
            researchers, and scholars. Since its inception, the library has
            remained committed to providing a peaceful environment for
            learning, research, and cultural activities.
          </p>

          <p className="about-paragraph">
            Located in Nazimabad, Karachi, the library serves thousands of
            readers every year and houses an extensive collection of books,
            journals, rare manuscripts, historical documents, and literary
            archives. It continues to inspire future generations through its
            dedication to education and cultural preservation.
          </p>
        </div>

        <div className="about-image-container">
          <img
            src={img2}
            alt="Ghalib Library"
            className="about-section-image"
          />
        </div>

      </section>


      {/* ================= HISTORY ================= */}

      <section className="about-content-section about-history">

        <div className="about-image-container">
          <img
            src={img3}
            alt="History of Ghalib Library"
            className="about-section-image"
          />
        </div>

        <div className="about-text">
          <h2 className="about-heading">
            Our History
          </h2>

          <div className="about-line"></div>

          <p className="about-paragraph">
            During the celebrations marking the centenary of Mirza Ghalib in
            1968, prominent literary personalities recognized the need for an
            institution dedicated to preserving Urdu literature and promoting
            scholarly research.
          </p>

          <p className="about-paragraph">
            This vision resulted in the establishment of
            <strong> Idara-e-Yadgar-e-Ghalib </strong>
            under the leadership of Faiz Ahmed Faiz and Mirza Zafar-ul-Hasan.
            Their efforts transformed a literary movement into one of
            Pakistan's most respected libraries.
          </p>

          <p className="about-paragraph">
            Since 1971, Ghalib Library has continued to organize literary
            seminars, book launches, research activities, and educational
            programs while preserving thousands of valuable publications.
          </p>
        </div>

      </section>


      {/* ================= FOUNDERS ================= */}

      <section className="about-content-section">

        <div className="about-text">
          <h2 className="about-heading">
            Visionary Founders
          </h2>

          <div className="about-line"></div>

          <p className="about-paragraph">
            Ghalib Library owes its existence to the dedication of renowned
            poet <strong>Faiz Ahmed Faiz</strong> and distinguished scholar
            <strong> Mirza Zafar-ul-Hasan.</strong>
          </p>

          <p className="about-paragraph">
            Their vision extended beyond establishing a traditional library.
            They sought to create an intellectual center where literature,
            education, culture, and research could flourish together while
            preserving Pakistan's literary identity.
          </p>

          <p className="about-paragraph">
            Through their leadership, the library became a gathering place for
            celebrated writers, poets, historians, journalists, and students,
            making it one of Karachi's most influential literary institutions.
          </p>
        </div>

        <div className="about-image-container">
          <img
            src={img4}
            alt="Visionary Founders"
            className="about-section-image"
          />
        </div>

      </section>


      {/* ================= ARCHITECTURE ================= */}

      <section className="about-content-section about-history">

        <div className="about-image-container">
          <img
            src={img5}
            alt="Ghalib Library Building"
            className="about-section-image"
          />
        </div>

        <div className="about-text">
          <h2 className="about-heading">
            A Landmark of Learning
          </h2>

          <div className="about-line"></div>

          <p className="about-paragraph">
            The Ghalib Library building, constructed in the early 1970s, is
            recognized as an important cultural landmark in Karachi. Designed
            to provide a peaceful and scholarly atmosphere, it has welcomed
            generations of readers, researchers, and literature enthusiasts.
          </p>

          <p className="about-paragraph">
            Spacious reading halls, research rooms, archives, and seminar
            facilities continue to support academic excellence while
            preserving the institution's historic identity.
          </p>
        </div>

      </section>


      {/* ================= COLLECTION ================= */}

      <section className="about-content-section">

        <div className="about-text">
          <h2 className="about-heading">
            Library Collection
          </h2>

          <div className="about-line"></div>

          <p className="about-paragraph">
            The library proudly maintains one of the richest collections of
            Urdu literature in Pakistan. Its shelves contain thousands of
            books covering literature, history, religion, philosophy, science,
            education, politics, and contemporary research.
          </p>

          <p className="about-paragraph">
            Alongside printed books, visitors can explore rare manuscripts,
            historical correspondence, vintage journals, and first editions of
            works by renowned scholars and poets.
          </p>
        </div>

        <div className="about-image-container">
          <img
            src={img6}
            alt="Library Collection"
            className="about-section-image"
          />
        </div>

      </section>


      {/* ================= MISSION & VISION ================= */}

      <section className="about-info-section">

        <div className="about-info-card">
          <h3>Our Mission</h3>

          <p>
            To preserve literary heritage, encourage research, provide equal
            access to knowledge, and inspire lifelong learning through quality
            library services and educational activities.
          </p>
        </div>

        <div className="about-info-card">
          <h3>Our Vision</h3>

          <p>
            To become one of Pakistan's leading centers of literature,
            education, research, and digital learning while promoting cultural
            understanding for future generations.
          </p>
        </div>

      </section>


      {/* ================= CORE VALUES ================= */}

      <section className="about-values-section">

        <h2 className="about-heading-center">
          Our Core Values
        </h2>

        <div className="about-line-center"></div>

        <div className="about-values-grid">

          <div className="about-value-card">
            <h3>📖 Knowledge</h3>

            <p>
              Promoting learning through quality books, journals and research
              materials.
            </p>
          </div>

          <div className="about-value-card">
            <h3>🎓 Education</h3>

            <p>
              Supporting students, teachers and researchers in their academic
              journey.
            </p>
          </div>

          <div className="about-value-card">
            <h3>🤝 Community</h3>

            <p>
              Creating an inclusive environment that welcomes readers from all
              backgrounds.
            </p>
          </div>

          <div className="about-value-card">
            <h3>🏛 Heritage</h3>

            <p>
              Preserving Pakistan's literary and cultural history for future
              generations.
            </p>
          </div>

        </div>

      </section>


      {/* ================= LIBRARY STATS ================= */}

      <section className="about-stats-section">

        <div className="about-stat-card">
          <h2>40,000+</h2>
          <p>Books</p>
        </div>

        <div className="about-stat-card">
          <h2>1,000+</h2>
          <p>Rare Manuscripts</p>
        </div>

        <div className="about-stat-card">
          <h2>50+</h2>
          <p>Years of Service</p>
        </div>

        <div className="about-stat-card">
          <h2>Thousands</h2>
          <p>Readers Every Year</p>
        </div>

      </section>


      {/* ================= CLOSING ================= */}

      <section className="about-closing-section">

        <h2 className="about-heading-center">
          Preserving the Past, Inspiring the Future
        </h2>

        <div className="about-line-center"></div>

        <p className="about-closing-text">
          Ghalib Library continues to serve as a symbol of knowledge,
          intellectual freedom, and cultural preservation. Through its vast
          collections, educational activities, and commitment to scholarship,
          the library remains dedicated to empowering generations of readers
          and researchers.
        </p>

      </section>

    </div>
  );
};

export default About;